import React from 'react';
import {
  Box,
  Slider,
  Typography,
} from '@mui/material';

import HomeBottomButtonOptionsSettings from '@core/dashboard/components/HomeBottomBar/HomeBottomButtonOptionsSettings';
import { LANGUAGES } from '@constants/language';

import { SettingsGeneralViewProps } from './interfaces';
import { useStyles } from './styles';
import { env } from 'env';
import { isDesktop } from 'react-device-detect';
import ReconnectExternalKeyboardButton
  from '@core/dashboard/components/Overlays/ExternalKeyboardOverlay/ReconnectExternalKeyboardButton';

const { REACT_APP_FEATURE_SHOW_LANGUAGE = 'true' } = env;

const showLanguage = REACT_APP_FEATURE_SHOW_LANGUAGE === 'true';

const SettingsGeneralView = ({
  selectLanguage,
  selectedLanguage,
  streamQuality,
  setStreamQuality,
  translate,
  gameSound,
  handleChange,
  participantsSound,
  handleLoudness,
  devices,
}: SettingsGeneralViewProps) => {
  const classes = useStyles();

  const languages = LANGUAGES.map(({ label, key }) => ({
    label,
    deviceId: key,
  }));

  return (
    <>
      {showLanguage ? (
        <HomeBottomButtonOptionsSettings
          devices={languages}
          handleSelect={(e) => selectLanguage(e.target.value)}
          label={translate('settingsModal.language')}
          selectedValue={selectedLanguage}
          sx={classes.buttonOptions}
        />
      ) : null}

      {/*<HomeBottomButtonOptionsSettings*/}
      {/*  devices={devices}*/}
      {/*  handleSelect={(e) => setStreamQuality(e.target.value)}*/}
      {/*  label={translate('settingsModal.quality')}*/}
      {/*  selectedValue={streamQuality}*/}
      {/*  SelectIcon={HighQualityIcon}*/}
      {/*/>*/}
      <Box sx={classes.slider}>
        <Typography sx={classes.label}>
          {translate('settingsModal.worldSound')}
        </Typography>
        <Slider
          aria-label="Volume"
          value={gameSound * 100}
          onChange={handleChange}
        />
      </Box>
      <Box sx={classes.slider}>
        <Typography sx={classes.label}>
          {translate('settingsModal.loudness')}
        </Typography>
        <Slider
          aria-label="Volume"
          value={participantsSound * 100}
          onChange={handleLoudness}
        />
      </Box>
      {!isDesktop && (
        <Box sx={classes.slider}>
          <ReconnectExternalKeyboardButton
            label={translate('settingsModal.reconnectExternalKeyboard')}
            fullWidth
            showReconnectedNotification
          />
        </Box>
      )}
    </>
  );
};

export default SettingsGeneralView;
